function createRegionOptionElement ({
	value = '', label = 'N/A', isSelected = false, isDefaultSelected = false
}) {

	return new Option(label, value, isDefaultSelected, isSelected);

}

export default createRegionOptionElement;
